// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBitGXIZ3GPvUpYiF38fhpjaBaNemDH__I",
    authDomain: "crystal-meth-thesis.firebaseapp.com",
    databaseURL: "https://crystal-meth-thesis-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "crystal-meth-thesis",
    storageBucket: "crystal-meth-thesis.appspot.com",
    messagingSenderId: "621344001118",
    appId: "1:621344001118:web:11545583017b66dfacf8cf",
    measurementId: "G-XCB8XE43HE"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
